<template>
  <v-container-with-title
    title="Tipo de clasificación"
    subtitle="Selecciona el seller dueño de las clasificaciones con las que quieres trabajar"
  >
    <v-layout justify-center wrap>
      <v-flex
        v-for="seller in availableClassificationsSellers"
        :key="seller.id"
        xs12
        sm6
        md3
        class="pa-2"
      >
        <v-seller-card v-bind="seller" />
      </v-flex>
    </v-layout>
  </v-container-with-title>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers("classifier");

import VContainerWithTitle from "@/components/containers/ContainerWithTitle";
import VSellerCard from "./components/SellerCard";

export default {
  components: {
    VContainerWithTitle,
    VSellerCard
  },
  computed: {
    ...mapState(["availableClassificationsSellers"])
  },
  /**
   * Remove the classifications' seller id to clean all the app.
   */
  created() {
    this.setClassificationsSellerId();
  },
  methods: {
    ...mapActions(["setClassificationsSellerId"])
  }
};
</script>